import { useEffect } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogViewEvent = () => {
  useEffect(() => {
    bridge.logAnalyticsEvent({
      name: 'VIEW_ALARM_SETTING',
      channel: ['firebase', 'amplitude', 'ablylog'],
      analytics: {
        SCREEN: 'ALARM_SETTING',
      },
    });
  }, []);
};
